import { useNavigate } from 'react-router-dom';
import { Mail, ArrowRight } from 'lucide-react';
import { Card, Button } from '../../../ui';

export function CampaignsLiveBlock() {
  const navigate = useNavigate();
  return (
    <Card>
      <div className="flex items-start justify-between">
        <div>
          <h2 className="font-serif text-lg text-ink-primary">Campanhas em curso</h2>
          <p className="text-sm text-ink-secondary mt-1">
            Acompanhe envios, taxas de abertura e clique.
          </p>
        </div>
        <Mail className="w-5 h-5 text-ink-tertiary" />
      </div>
      <Button
        variant="secondary"
        size="sm"
        className="mt-4"
        icon={<ArrowRight className="w-4 h-4" />}
        iconPosition="right"
        onClick={() => navigate('/campanhas')}
      >
        Abrir Campanhas
      </Button>
    </Card>
  );
}
